<script setup lang="ts">
import DirectionOrgGridSkeleton from '~/components/Direction/page/DirectionOrgGridSkeleton.vue'
</script>

<template>
  <div class="national-loading" aria-busy="true">
    <div class="skeleton-title" aria-label="Chargement du titre">
      <div class="skeleton-title-inner" />
    </div>
    <DirectionOrgGridSkeleton />
  </div>
</template>

<style scoped lang="scss">
@use "~/assets/scss/partials/elpdl/index" as *;
@use "~/assets/scss/partials/elpdl/spacing" as spacing;
@use "~/assets/scss/partials/elpdl/colors" as c;

.national-loading {
  min-height: min(70dvh, 28rem);
  padding-bottom: spacing.$spacing-xl;
}

.skeleton-title {
  border-radius: $spacing-2xs;
  overflow: hidden;
  background: c.$enedis-neutral-40;
  text-align: center;
  max-width: 60%;
  height: 3rem;
  margin: $spacing-xs auto $spacing-l;
}

.skeleton-title-inner {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
}

.skeleton-title-inner::after {
  content: "";
  position: absolute;
  inset: 0;
  transform: translateX(-100%);
  background: linear-gradient(
    90deg,
    rgba(c.$enedis-neutral-40, 0) 0%,
    rgba(255, 255, 255, 0.7) 50%,
    rgba(c.$enedis-neutral-40, 0) 100%
  );
  animation: shimmer 1.2s infinite;
}

@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
</style>
